import { useState } from 'react'
import { useWindowSize } from '../../../../../core/hooks/common/useWindowSize'
import { TABLET_SIZE } from '../../../../../core/constants/common'
import {
    CacheKeys,
    vasOptions,
} from '../../../../../core/constants/filter'
import FilterLayout from '../../../../layout/filter/FilterLayout'
import VAsTable from './VAsTable'
import { useGetVAs } from '../../../../../core/services/react-query/report/due-payments'
import RVAsTable from './RVAsTable'

const VAsList = () => {
    const { width } = useWindowSize()
    const [vas, setVas] = useState({ data: null, loading: true })


    const onQuerySuccess = (res) => {
        setVas(res)

    }

    const Component = width > TABLET_SIZE ? VAsTable : RVAsTable

    return (
        <FilterLayout
            query={useGetVAs}
            onQuerySuccess={onQuerySuccess}
            options={vasOptions}
            cache={CacheKeys.VAS}
        >
            {width && <Component data={vas} />}
        </FilterLayout>
    )
}

export default VAsList
